import { ViewFactory } from 'wdc-cube-react'
import AnaliseScope, { HeaderScope } from '../analise.scopes'
import AnaliseView from './analise.view'
import HeaderView from './analise.header'

export function registerViews(rv = ViewFactory.register) {
    rv(AnaliseScope, AnaliseView)
    rv(HeaderScope, HeaderView)
}
